import React from "react";
import "./MaintenanceBanner.css";

const MaintenanceBanner = () => {
  return (
    <div className="maintenance-banner">
      <span className="maintenance-icon">🛠️</span>

      <div className="maintenance-content">
        <strong>Website Maintenance</strong>
        <span>
          We’re currently performing maintenance. Some features may be limited
          or temporarily unavailable.
        </span>
      </div>
    </div>
  );
};

export default MaintenanceBanner;